import script from "./RankListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./RankListItem.vue?vue&type=script&setup=true&lang=js"

import "./RankListItem.vue?vue&type=style&index=0&id=c7d2c948&lang=less&scoped=true"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7d2c948"]])

export default __exports__